module.exports = __webpack_public_path__ + "static/media/Primary_Visa.d88b307f.svg";